import React from "react";
import Nav from "react-bootstrap/Nav";
import {Link} from "react-router-dom"
import "./NavBar.css"
import menuConfig from "../../assets/configs/menuConfig";
import footerConfig from "../../assets/configs/footerConfig";

const NavBarItems = (props) => {

    return (
        <>
            <Nav className="me-auto">
                {menuConfig.sidebarData.map((item) => (
                        <Nav.Item key={item.id}>
                            <Nav.Link as={Link} to={item.path} onClick={props.onSelection}>
                                {item.icon}
                                <span>{item.title}</span>
                            </Nav.Link>
                        </Nav.Item>

                    )
                )}
            </Nav>
            <Nav>
                {footerConfig.icons.map((item) => (
                    <Nav.Item key={item.id}>
                        <Nav.Link 
                            href={item.url} 
                            target={item.target} 
                            rel={"noopener noreferrer"}
                            className="social-nav-link"
                        >
                            {React.cloneElement(item.icon, { size: 25 })}
                        </Nav.Link>
                    </Nav.Item>
                ))}
            </Nav>
        </>
    )
}

export default NavBarItems